import React, { FC, useId, useState } from 'react';
import styles from './styles.module.sass';
import { ButtonType } from 'types/enums';
import { Button, Loader } from 'components';
import { FormControlLabel, Switch, Input } from '@mui/material';
import { removeDCBias } from 'utils/util';
import { downloadCsvHelper } from '../../helpers/helpers';
import { DBEcgItem, DownloadECGItem } from 'types/types';
import { useStudyController } from './hooks/use-study-controller';

type Properties = {
  everbeatData: DBEcgItem;
  referenceData: DownloadECGItem;
  subjectId: string;
  onAlignmentEnd: () => void;
  getComparedSamples: () => {
    intEverbeatSamples: number[];
    intReferenceSamples: number[];
  };
};
export const StudyItemController: FC<Properties> = ({
  everbeatData,
  referenceData,
  subjectId,
  onAlignmentEnd,
  getComparedSamples,
}) => {
  const {
    onAlignmentSave,
    onDownloadAnalysisSamples,
    onDownloadFullAnalysisSamples,
    isAnalysisLoading,
    isFullAnalysisLoading,
    isAlignmentSaving,
    alignmentCommentRef,
  } = useStudyController({
    waveformId: everbeatData.id,
    patientName: everbeatData?.patientName ?? 'no patient name, waveform id - ' + everbeatData.id,
    subjectId,
    assessment: everbeatData?.assessment ?? '',
    onAlignmentEnd,
    getComparedSamples,
  });
  const alignmentInputId = useId();
  const [isAligned, setIsAligned] = useState(true);

  const handleAlignmentChange = () => setIsAligned((prev) => !prev);

  const handleCreateEverbeatCsvClick = () => {
    const deibasSamples = removeDCBias(everbeatData.samples);
    downloadCsvHelper(deibasSamples, `Everbeat-${everbeatData?.patientName ?? 'ecg'}.csv`);
  };

  return (
    <>
      <Loader isVisible={isAlignmentSaving} isOverlay />
      <div className={styles.btn_container}>
        <Button onClick={handleCreateEverbeatCsvClick} buttonType={ButtonType.SECONDARY}>
          Download everbeat CSV
        </Button>
        <div>
          <FormControlLabel
            control={<Switch defaultChecked onChange={handleAlignmentChange} />}
            label={isAligned ? 'Aligned' : 'Not Aligned'}
          />
          {!isAligned && (
            <div className={styles.label}>
              <label htmlFor={alignmentInputId}>Please explain why alignment failed:</label>
              <Input className={styles.comment} inputRef={alignmentCommentRef} id={alignmentInputId}></Input>
            </div>
          )}
        </div>
        <Button disabled={!referenceData} onClick={onAlignmentSave} buttonType={ButtonType.SECONDARY}>
          Save
        </Button>
        {referenceData && (
          <>
            <Button isLoading={isAnalysisLoading} onClick={onDownloadAnalysisSamples} buttonType={ButtonType.OUTLINE}>
              Export XML for Analysis
            </Button>
            <Button
              isLoading={isFullAnalysisLoading}
              onClick={onDownloadFullAnalysisSamples}
              buttonType={ButtonType.PRIMARY}
            >
              Download Full Sample Analysis
            </Button>
          </>
        )}
      </div>
    </>
  );
};
